"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogbookBasicSubscriptionBadge = LogbookBasicSubscriptionBadge;
exports.LogbookPremiumSubscriptionBadge = LogbookPremiumSubscriptionBadge;
exports.SalesSubscriptionBadge = SalesSubscriptionBadge;
exports.FishingWaterSubscriptionBadge = FishingWaterSubscriptionBadge;
exports.LodgeSubscriptionBadge = LodgeSubscriptionBadge;
exports.SubscriptionPackageBadge = SubscriptionPackageBadge;
exports.SubscribedWaterwayProductBadges = SubscribedWaterwayProductBadges;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../utils");
const sizeStyles = {
    default: 'px-3 py-1 text-[11px]',
    sm: 'px-1.5 py-0.5 text-[10px]'
};
// Reserved product tints. Three are tokenised in @aiq/config tokens.css:
//   permits  — blue   → SALES product
//   logbook  — green  → LOGBOOK_BASIC + LOGBOOK_PREMIUM (one tint per product line)
//   water    — yellow → Fishing Water marketplace
//
// TODO(design-handoff): the Lodge product is new (LODGE_BASIC subscription
// landed in 0053). It needs its own token triplet (bg/fg/bd) in tokens.css
// — currently using inline Tailwind violet shades as a placeholder. Either
// promote the inline classes to tokens (preferred) or pick a different
// tint if violet collides with anything design didn't intend.
const toneStyles = {
    permits: 'bg-badge-permits-bg text-badge-permits-fg border-badge-permits-bd',
    logbook: 'bg-badge-logbook-bg text-badge-logbook-fg border-badge-logbook-bd',
    water: 'bg-badge-water-bg text-badge-water-fg border-badge-water-bd',
    lodge: 'bg-violet-100 text-violet-900 border-violet-300'
};
function SubscriptionBadgeFrame({ children, className, size = 'default', tone }) {
    return ((0, jsx_runtime_1.jsx)("span", { className: (0, utils_1.cn)('inline-flex items-center rounded-full border font-bold uppercase tracking-[0.08em]', toneStyles[tone], sizeStyles[size], className), children: children }));
}
function LogbookBasicSubscriptionBadge({ label, className, size }) {
    return ((0, jsx_runtime_1.jsx)(SubscriptionBadgeFrame, { className: className, size: size, tone: 'logbook', children: label }));
}
function LogbookPremiumSubscriptionBadge({ label, className, size }) {
    return ((0, jsx_runtime_1.jsx)(SubscriptionBadgeFrame, { className: className, size: size, tone: 'logbook', children: label }));
}
function SalesSubscriptionBadge({ label, className, size }) {
    return ((0, jsx_runtime_1.jsx)(SubscriptionBadgeFrame, { className: className, size: size, tone: 'permits', children: label }));
}
function FishingWaterSubscriptionBadge({ label, className, size }) {
    return ((0, jsx_runtime_1.jsx)(SubscriptionBadgeFrame, { className: className, size: size, tone: 'water', children: label }));
}
function LodgeSubscriptionBadge({ label, className, size }) {
    return ((0, jsx_runtime_1.jsx)(SubscriptionBadgeFrame, { className: className, size: size, tone: 'lodge', children: label }));
}
function SubscriptionPackageBadge({ code, labels, className, size }) {
    if (code === 'LOGBOOK_PREMIUM') {
        return (0, jsx_runtime_1.jsx)(LogbookPremiumSubscriptionBadge, { className: className, label: labels.LOGBOOK_PREMIUM, size: size });
    }
    if (code === 'SALES') {
        return (0, jsx_runtime_1.jsx)(SalesSubscriptionBadge, { className: className, label: labels.SALES, size: size });
    }
    if (code === 'LODGE_BASIC') {
        return (0, jsx_runtime_1.jsx)(LodgeSubscriptionBadge, { className: className, label: labels.LODGE_BASIC, size: size });
    }
    return (0, jsx_runtime_1.jsx)(LogbookBasicSubscriptionBadge, { className: className, label: labels.LOGBOOK_BASIC, size: size });
}
/** Matches business-web dashboard waterway cards: premium logbook badge wins over basic when both exist. */
function SubscribedWaterwayProductBadges({ hasLogbookBasic, hasLogbookPremium, hasSales, hasLodge, labels, className, size }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, utils_1.cn)('flex flex-wrap gap-1.5', className), children: [hasLogbookPremium ? ((0, jsx_runtime_1.jsx)(LogbookPremiumSubscriptionBadge, { label: labels.logbookPremium, size: size })) : hasLogbookBasic ? ((0, jsx_runtime_1.jsx)(LogbookBasicSubscriptionBadge, { label: labels.logbookBasic, size: size })) : null, hasSales ? (0, jsx_runtime_1.jsx)(SalesSubscriptionBadge, { label: labels.sales, size: size }) : null, hasLodge && labels.lodge ? (0, jsx_runtime_1.jsx)(LodgeSubscriptionBadge, { label: labels.lodge, size: size }) : null] }));
}
